import { render } from "./ProblemsSection.vue?vue&type=template&id=897f7958&scoped=true"
import script from "./ProblemsSection.vue?vue&type=script&lang=js"
export * from "./ProblemsSection.vue?vue&type=script&lang=js"

import "./ProblemsSection.vue?vue&type=style&index=0&id=897f7958&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897f7958"]])

export default __exports__